import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import BranchFollowGroupsActions from "./widget/BranchFollowGroupsActions";
import BranchFollowGroupContent from "./BranchFollowGroupsContent";
import { HomeContextProvider } from "../../../provider/home/HomeContextProvider";
import { BranchFollowGroupsContextProvider } from "../../../provider/branch/branch_follow_groups/BranchFollowGroupsContextProvider";
import BranchFollowGroupsButtons from "./widget/BranchFollowGroupsButtons";

const BranchFollowGroupsScreen = () => {
  const type: number = ResponsiveDeviceType();


  return (
    <HomeContextProvider>
      <BranchFollowGroupsContextProvider>
        <Scaffold
          appBarTitle={AppTranslation.text("follow_groups")}
          appBarAction={<BranchFollowGroupsActions />}
          bottomNavigationButton={<BranchFollowGroupsButtons type={type} />}
        >
          <MainBodyContainer>
            <BranchFollowGroupContent />
          </MainBodyContainer>
        </Scaffold>
      </BranchFollowGroupsContextProvider>
    </HomeContextProvider>
  );
};

export default BranchFollowGroupsScreen;
export const routeName: string = "/branch-folow-groups";
